import { snakeCase } from 'lodash';

export enum ProjectEvents {
  ProjectUpdate = 'project_update',
}

export const ProjectEventsMap: Record<string, string> = Object.keys(
  ProjectEvents,
).reduce((acc, key) => {
  acc[snakeCase(key).toUpperCase()] = ProjectEvents[key];

  return acc;
}, {} as Record<string, string>);
